import React, { useEffect,useState } from "react";
import About from "../Images/Summit.png";
import Summit2 from "../Images/summit2.png";
import WOW from "wow.js";
import { IconBrandLinkedin } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export const WhyCorvanta = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const wow = new WOW();
    wow.init();
    
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    <div
      className="w-full font-sans "
      id="whycorvanta"
      // style={{
      //   background:
      //     "linear-gradient(90deg, rgba(147,109,247,0.9389005602240896) 0%, rgba(138,227,255,1) 100%)",
      // }}
    >
      <div
        className="section"
        id="aboutus"
        style={{ textAlign: "justify", textJustify: "auto" }}
      >
        <div className="sm:px-2">
          <div className="px-10 flex flex-col lg:flex-row justify-around items-start lg:items-center" dir="auto">
          <div className="image  wow slideInLeft mb-6">
              {/* {isMobile ? (
                <img
                  className="mt-4 ml-1 lg:mt-8 w-full mb-4 lg:mb-8 h-96 rounded-2xl wow slideInLeft"
                  src={Summit2}
                  alt="Logo Image"
                />
              ) : ( */}
                <img
                  className="mt-4 ml-1 lg:mt-8 w-full mb-4 lg:mb-8 h-96 rounded-2xl wow slideInLeft"
                  src={About}
                  alt="Logo Image"
                />
              {/* )} */}
              <div className="rtl:flex-row-reverse flex gap-2 items-center rtl:justify-end">
  <div className="font-bold text-white text-xl rtl:text-right">
              {t('whyCorvanta.founderName')}
              </div>
              <div className="">
                <a
                  href="https://www.linkedin.com/in/rajamohd/" 
                  label="LinkedIn"
                >    <IconBrandLinkedin size={25} style={{ color: "#FFFFFF" }} /></a>
              </div>
              </div>
             
              <div className="text-gray-300 font-semibold text-lg rtl:text-right">
              {t('whyCorvanta.founderTitle')}
              </div>
            </div>

           {/* text content */}
            <div className="w-full lg:w-1/2 flex flex-col justify-start items-start lg:items-start rtl:text-right  rtl:lg:mr-[40rem] rtl:lg:-mt-[32rem]">

              <div className="wow slideInRight lg:p-10">
              <span className="">
                <svg
                  width="129"
                  height="27"
                  viewBox="0 0 129 27"
                  fill="#ffffff"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mb-6"
                >
                  <rect width="4" height="27" fill="#ffffff" />
                  <rect x="25" width="4" height="27" fill="#ffffff" />
                  <rect x="50" width="4" height="27" fill="#ffffff" />
                  <rect x="75" width="4" height="27" fill="#ffffff" />
                  <rect x="100" width="4" height="27" fill="#ffffff" />
                  <rect x="125" width="4" height="27" fill="#ffffff" />
                </svg>
              </span>
                <div className="text-5xl  font-geo text-[#EF3B3B] flex justify-start font-bold mb-2 lg:mb-6 self-start wow fadeInUp">
                  {t('whyCorvanta.title')}
                </div>
                <div className="text-lg  text-white  text-left font-medium  mb-2 lg:mb-6" >
                  {t('whyCorvanta.description1')}
                </div>
                <div className="lg:text-lg text-[15px]  text-white font-normal text-left mb-2 lg:mb-6 ">
                 {t('whyCorvanta.description2')}
                <div className="mt-2 text-justify leading-normal">
                {t('whyCorvanta.description3')}
                </div>
                </div>
                <div className="text-lg wow fadeInInUp text-white font-medium leading-relaxed mb-2 lg:mb-6">
                  {t('whyCorvanta.innovationCare')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
